/**
 * BookableResourceNoteService
 * Service for managing bookable resource notes
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for bookable resource note CRUD operations
 */
export class BookableResourceNoteService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? BookableResourceNoteService.DEFAULT_SERVICE_PATH,
            basePath: BookableResourceNoteService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
BookableResourceNoteService.DEFAULT_SERVICE_PATH = 'booking-management';
BookableResourceNoteService.BASE_PATH = 'api/bookable-resource-notes';
//# sourceMappingURL=BookableResourceNoteService.js.map